import React from 'react';
import { useParams } from 'react-router-dom';
import TrainingTree from './TrainingTree';

const MemberPage = () => {
  const { siteId, id: memberId } = useParams(); // Obtiene el siteId y memberId desde la URL

  return (
    <div>
      <h1>Member Training Tree</h1>
      <TrainingTree memberId={memberId} siteId={siteId} />
    </div>
  );
};

export default MemberPage;

